import React from 'react';
import stringHelper from '../../../Helpers/stringHelper';

// Design-system numeric field: a centered integer input flanked by −/+ steppers.
// Wired to InputTypesEnum.Number / Number2. Keeps the same onChange(fieldName, value)
// contract as TextField's number path — value is an int, or '' when cleared/blank.
// With showSteppers=false (InputTypesEnum.NumberWithoutSteppers) the −/+ buttons are
// omitted — for typed identifiers (ids, codes) where stepping makes no sense.

const toInt = (raw) => {
  const parsed = parseInt(raw, 10);
  return Number.isNaN(parsed) ? 0 : parsed;
};

export default function NumberStepper(props) {
  const { fieldName, onChange, value, placeholder, step, showSteppers } = props;

  const emit = (raw) => {
    const parsed = parseInt(raw, 10);
    onChange(fieldName, Number.isNaN(parsed) ? '' : parsed);
  };

  const display = value === null || value === undefined ? '' : stringHelper.removeTrailingZeros(value);

  return (
    <div className={'ds-stepper' + (showSteppers ? '' : ' ds-stepper--plain')}>
      {showSteppers ? (
        <button
          type='button'
          tabIndex={-1}
          aria-label='Decrease'
          onClick={() => emit(toInt(value) - step)}
        >
          −
        </button>
      ) : null}
      <input
        type='text'
        inputMode='numeric'
        id={`htmlidfor${fieldName}`}
        autoComplete='off'
        value={display}
        placeholder={placeholder}
        onChange={(e) => emit(e.target.value)}
      />
      {showSteppers ? (
        <button
          type='button'
          tabIndex={-1}
          aria-label='Increase'
          onClick={() => emit(toInt(value) + step)}
        >
          +
        </button>
      ) : null}
    </div>
  );
}

NumberStepper.defaultProps = {
  fieldName: 'defaultFieldname',
  onChange: () => {},
  value: null,
  placeholder: '',
  step: 1,
  showSteppers: true,
};
